var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-banner",class:{ 'hero-banner--has-img': _vm.img },style:(_vm.style)},[_c('v-container',[_c('div',{staticClass:"hero-banner__content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }